import { useState } from "react";
import FloatingLabelInput from "../../Common/FloatingLabel";
import { FcGoogle } from "react-icons/fc";
import { ForgetForm } from "../../api/api";
import toast, { Toaster } from "react-hot-toast";
import Spinner from "../../Common/Spinner";
import { useNavigate } from "react-router-dom";
import { handleApiError } from "../../Common/Helper";
const Forget = () => {
  const [FogetForm, setFogetForm] = useState([]);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState();
  const navigate = useNavigate();
  const handleChange = (e) => {
    setFogetForm({ ...FogetForm, [e.target.name]: e.target.value });
  };
  const validate = () => {
    const newErrors = {};
    // Email Validation
    if (!FogetForm.email) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(FogetForm.email)) {
      newErrors.email = "Email is invalid";
    }

    return newErrors;
  };
  const handleSubmit = (e) => {
    setLoading(false);
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
    } else {
      setLoading(true);
      const formData = new FormData();
      for (const key in FogetForm) {
        if (FogetForm.hasOwnProperty(key)) {
          formData.append(key, FogetForm[key]);
        }
      }
      ForgetForm(formData)
        .then((res) => {
          console.log(res);
          setLoading(false);
          if (res.success && res.status_code === "200") {
            toast.success("Link Send Succesfully");
          } else {
            handleApiError(res, navigate); // Use helper function
            setLoading(false);
          }
        })
        .catch((err) => {
          console.log(err);
          toast.error("Unable to send link");
        });
    }
  };
  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleSubmit(event); // Manually trigger the submit on Enter key
    }
  };
  return (
    <>
      <Toaster />
      <div>
        {/* <FloatingLabelInput
          label="Email Address"
          type="email"
          id="email"
          name="email"
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
        /> */}
        <div className="container">
          <div className="grid grid-cols-2 max-md:grid-cols-1 text-black items-center">
            <div className="bg-[#fff] max-md:w-full  px-[40px] py-[20px]  h-auto rounded-lg">
              <h3 className="text-[30px] max-lg:text-[24px] font-bold ">
                Forgot your password?
              </h3>
              <p className="text-slate-500 text-[14px] pt-4">
                Please enter your email address and we’ll send you a link to
                reset your password
              </p>
              <div className="my-5">
                <FloatingLabelInput
                  label="Email Address"
                  type="email"
                  id="email"
                  name="email"
                  value={FogetForm.email}
                  onBlur={() => setErrors(validate())} // Validate on blur
                  error={errors.email}
                  required
                  onChange={(e) => {
                    handleChange(e);
                  }}
                  onKeyDown={handleKeyPress}
                />
              </div>

              <div>
                {loading === false || loading === undefined ? (
                  <button
                    onClick={(e) => handleSubmit(e)}
                    className="w-full py-3 mt-3 text-white font-bold bg-primary rounded  "
                  >
                    Send a Reset Link
                  </button>
                ) : (
                  <button className="w-full text-center flex justify-center py-3 mt-3 text-white font-bold bg-primary rounded  ">
                    <Spinner />
                  </button>
                )}
              </div>
              <p className="text-right py-2">
                <a href="/" className="underline">
                  Back to login page
                </a>
              </p>
            </div>
            <div className="max-lg:hidden">
              <div className="fixed bottom-0 2xl:w-[800px] lg:w-[500px] right-[6%] flex justify-center">
                <img
                  src="/assets/images/1.png"
                  alt="wills-guru-logo-white"
                  className="h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Forget;
